import { render, staticRenderFns } from "./AuthorizeDropBox.vue?vue&type=template&id=5df7a082&scoped=true&"
import script from "./AuthorizeDropBox.vue?vue&type=script&lang=js&"
export * from "./AuthorizeDropBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df7a082",
  null
  
)

export default component.exports